import { render, staticRenderFns } from "./ShadowContainer.vue?vue&type=template&id=7846f0bf&scoped=true&"
import script from "./ShadowContainer.vue?vue&type=script&lang=js&"
export * from "./ShadowContainer.vue?vue&type=script&lang=js&"
import style0 from "./ShadowContainer.vue?vue&type=style&index=0&id=7846f0bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7846f0bf",
  null
  
)

export default component.exports